
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/baseUI/FacesRating/FacesRating.scss.css.virtualfile';
        module.exports = {"container":"_container_1t2zw_7","icon":"_icon_1t2zw_11","selected":"_selected_1t2zw_15"};